// WorkflowEngine (§18-§21). Vyhodnocuje povolené přechody, oprávnění rolí a
// konfigurovatelná pravidla. Nezná UI ani úložiště — čistá doménová logika.
import { resolveWorkflow, RULES } from "./WorkflowDefinition.js";

export class WorkflowEngine {
  constructor(definition) { this.def = resolveWorkflow(definition); }

  get states() { return this.def.states.slice(); }
  get initialState() { return this.def.initial || this.def.states[0]; }

  currentState(topic) { return (topic.workflow && topic.workflow.state) || topic.status || this.initialState; }

  allowedTransitions(topic) {
    const from = this.currentState(topic);
    return (this.def.transitions[from] || []).slice();
  }

  // Může se téma dostat do cílového stavu? Vrací { ok, error? }.
  canTransition(topic, toState, ctx = {}) {
    const from = this.currentState(topic);
    if (!this.def.states.includes(toState)) return { ok: false, error: `Neznámý stav: ${toState}` };
    if (from === toState) return { ok: true };
    const allowed = this.def.transitions[from] || [];
    if (!allowed.includes(toState)) return { ok: false, error: `Přechod ${from} → ${toState} není povolen.` };

    // Oprávnění rolí (§21).
    const perms = (this.def.permissions && this.def.permissions[toState]) || null;
    if (perms && perms.length && !perms.includes(ctx.role)) return { ok: false, error: `Přechod do stavu „${toState}" vyžaduje roli: ${perms.join(", ")}.` };

    // Konfigurovatelná pravidla (§20).
    const ruleCtx = { toState, fromState: from, role: ctx.role, userId: ctx.userId };
    for (const name of this.def.rules || []) {
      const rule = RULES[name];
      if (!rule) continue;
      const res = rule(topic, ruleCtx);
      if (res !== true) return { ok: false, error: typeof res === "string" ? res : `Porušeno pravidlo: ${name}` };
    }
    return { ok: true };
  }
}
